import React from 'react';
import { LevelName } from '../../utils/enums';
import './plan-and-upgrade.scss';
import SilverSvg from '@svg/silver-active.svg?react';
import BronzeSvg from '@svg/bronze-active.svg?react';
import DDLogo from '@svg/dd-logo.svg?react';
import { observer } from 'mobx-react-lite';
import { Link } from 'react-router-dom';
import { envBusinessCenterDomain } from '../../utils/envLinksUtil';

interface PlanAndUpgradeProps {
    serviceLevel?: LevelName;
}

const PlanAndUpgrade: React.FC<PlanAndUpgradeProps> = observer(({serviceLevel = LevelName.BRONZE} ) => {

    return (
        <div className="plan-upgrade-wrapper">
            <div className="plan-header">
               <DDLogo />
            </div>
            <div className="upgrade-wrapper">
                <div className="upgrade-text">Upgrade your plan for more advanced features and full protection for your business. </div>
                <Link to={`https://${envBusinessCenterDomain}/ebiz/emaintenance/v2/#/inventoryPage`} target="_blank" rel="noreferrer">
                    <div className="upgrade-btn">Upgrade now</div>
                </Link>
            </div>
            <div className="upgrade-table">
                { serviceLevel === LevelName.SILVER ? <SilverSvg /> : <BronzeSvg /> }
            </div>
        </div>
    );
});

export default PlanAndUpgrade;

